/* THIS FILE IS AUTO-GENERATED – DO NOT EDIT */

import {forwardRef} from 'react'

/**
 * @public
 */
export const DocumentVideoIcon = forwardRef(function DocumentVideoIcon(
  props: React.SVGProps<SVGSVGElement>,
  ref: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      data-sanity-icon="document-video"
      width="1em"
      height="1em"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...props}
    >
      <path
        d="M11.5 16.5V13.5L14 15L11.5 16.5Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={1.2}
      />
      <path d="M11.5 4.5V9.5H6.5" stroke="currentColor" strokeWidth={1.2} strokeLinejoin="round" />
      <path
        d="M11.5 4.5H18.5V20.5H6.5V9.5L11.5 4.5Z"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeLinejoin="round"
      />
    </svg>
  )
})
DocumentVideoIcon.displayName = 'ForwardRef(DocumentVideoIcon)'
